<div class="tp-page tp-page--compact">
  <section class="tp-card tp-card--flush">
    <tp-page-header variant="toolbar" title="Accesorios opcionales"
    [subtitle]="optionalAccessories.length + ' accesorios'">
    </tp-page-header>
    <div class="tp-table-responsive">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>Descripción</th>
            <th>Tipo</th>
            <th>Editable</th>
            <th>Promocional</th>
          </tr>
        </thead>
        <tbody>
          @for (accessory of optionalAccessories; track accessory) {
            <tr>
              <td>{{ accessory.description }}</td>
              <td>{{ accessory.type }}</td>
              <td>
                <button
                  type="button"
                  class="btn-status"
                  [ngClass]="accessory.isEditable ? 'btn-on' : 'btn-off'"
                  (click)="updateVariables(accessory, !accessory.isEditable, accessory.isPromotionalAccessory)"
                >
                  {{ accessory.isEditable ? "Editable" : "No editable" }}
                </button>
              </td>
              <td>
                <button
                  type="button"
                  class="btn-status"
                  [ngClass]="accessory.isPromotionalAccessory ? 'btn-on' : 'btn-off'"
                  (click)="updateVariables(accessory, accessory.isEditable, !accessory.isPromotionalAccessory)"
                >
                  {{ accessory.isPromotionalAccessory ? "En promoción" : "No promocional" }}
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4">
                <tp-empty-state
                  icon="extension"
                  title="Sin accesorios opcionales"
                  message="Cuando haya accesorios opcionales los vas a ver acá."
                ></tp-empty-state>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</div>
